module.exports = __webpack_public_path__ + "static/sectionafter-5a6b5dca2870bb3abc5d4a85d643d8ec.png";